/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ContentCategoryDto } from '../../models/content-category-dto';

export interface AdminContentCategoryControllerFindById$Params {

/**
 * 카테고리 ID
 */
  id: string;
}

export function adminContentCategoryControllerFindById(http: HttpClient, rootUrl: string, params: AdminContentCategoryControllerFindById$Params, context?: HttpContext): Observable<StrictHttpResponse<ContentCategoryDto>> {
  const rb = new RequestBuilder(rootUrl, adminContentCategoryControllerFindById.PATH, 'get');
  if (params) {
    rb.path('id', params.id, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ContentCategoryDto>;
    })
  );
}

adminContentCategoryControllerFindById.PATH = '/api/content-category/admin/{id}';
